module.exports = __webpack_public_path__ + "static/img/product_images_30_h5_zh.bbf204d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_30_h5_zh.png
// module id = kNTe
// module chunks = 34